export default class Failure {
  message: string;
  code: string;

  // Constructor
  constructor(message: string, code: string) {
    this.message = message;
    this.code = code;
  }
}
